<template>
	<div class="reserve-background-width">
		<v-img
			v-if="reservedaysData.mainimg"
			:src="$store.state.frontServer_upload + reservedaysData.mainimg.url"
			@error="imgError()"
			class="imageButton"
		>
		</v-img>
		<v-img v-else-if="reservedaysData.mainimg === null" :src="defaultImg" class="imageButton"> </v-img>

		<div class="reserveInfo">
			{{ reservedaysData.title }} <br />
			<!-- 서비스 참여기간 : {{ reservedaysData.sdate | moment('YYYY.MM.DD (ddd)') }} ~ {{ reservedaysData.edate | moment('YYYY.MM.DD (ddd)') }} -->
		</div>
		<v-layout class="pa-4" wrap justify-center>
			<v-flex xs12>
				<btn
					:btn="nextbtn"
					:btn_txt="reservedaysData.btnText ? reservedaysData.btnText : '시작하기'"
					:style="`color:${$store.state.PointColor8}`"
					@click="startSurvey"
				></btn>
			</v-flex>
		</v-layout>
		<!-- 이름 전화 번호 입력 모달 -->
		<reserveStart :setdialog="startDialog" :reservedaysData="reservedaysData" :nextStep="nextStep"></reserveStart>
		<!-- 드래그 버전 설문 모달 -->
		<reservevisitModalDrag :setdialog="reserveDialog" :title="placeTitle" :reservedaysData="reservedaysData"></reservevisitModalDrag>

		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
	</div>
</template>

<script>
import { btn, reserveStart, reservevisitModalDrag, alertModal5 } from '@/components/index.js'
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'
export default {
	components: {
		btn,
		reserveStart,
		reservevisitModalDrag,
		alertModal5,
	},
	metaInfo() {
		return {
			// 페이지 제목 캠페인 명에 따라 변경
			title: this.campaignTitle,
		}
	},
	data() {
		return {
			defaultImg: require('@/../public/image/default_main.png'),
			placeTitle: '',
			nametxtField: { value: '', outlined: true, placeholder: '성명을 입력하세요.' },
			numSel: { value: '010', outlined: true, class: 'selectNum', items: ['010', '011', '016', '017'] },
			numtxtField: { value: '', outlined: true, placeholder: '숫자만 입력하세요', onlyNumber: true, maxlength: 8 },
			nextbtn: {
				block: true,
				large: true,
				class: 'customBtn',
				color: this.$store.state.PointColor7,
			},
			backbtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			reserveDialog: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			reserveDialog1: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			startDialog: {
				step1: true,
				dialog: false,
				nametxtField: { value: '', outlined: true, placeholder: '성명을 입력하세요.', color: 'black' },
				numSel: { value: '010', outlined: true, class: 'selectNum', items: ['010', '011', '016', '017'], color: 'black' },
				numtxtField: {
					value: '',
					outlined: true,
					placeholder: '숫자만 입력하세요',
					onlyNumber: true,
					maxlength: 8,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
				phonetxtField: {
					value: '',
					outlined: true,
					placeholder: '문자로 전송된 인증번호를 입력하세요',
					onlyNumber: true,
					maxlength: 6,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
			},
			trackingCodes: [],
			reservedaysData: { business: { QRlogo: null } },
			alertModal: {
				dialog: false,
				text: '이름과 전화번호를 입력해 주세요.',
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			noInputBox: false,
			campaignTitle: '',
			surveyLegnth: 0,
			agreeContent: '',
			message: '',
			messageData1: {}, // create / update 알림톡 데이터
			messageData4: {}, // 내가받을 알림톡 알림톡 데이터
		}
	},
	async created() {
		this.$moment.locale('ko', {
			weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
			weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
		})

		await this.reservedays()
	},
	methods: {
		loc_firstSelect(val) {
			this.$store.state.searchsel_city2.items = location1[val].sort()
		},
		loc_twoSelect(val) {
			this.$store.state.searchsel_city3.items = location2[this.$store.state.searchsel_city1.value][val].sort()
		},
		imgError() {
			this.reservedaysData.mainimg = null
		},
		getLength() {
			let index = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 90)
			if (index !== -1) {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length - 1
				this.$store.state.reservedayInputBox.categories.splice(index, 1)
			} else {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length
			}
			let dateIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 30)
			if (dateIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(dateIndex, 1)
				this.surveyLegnth--
			}
			let timeIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 31)
			if (timeIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(timeIndex, 1)
				this.surveyLegnth--
			}
		},
		createTrackingCode() {
			const data = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.$store
				.dispatch('createTrackingCode', data)
				.then(res => {
					this.$store.state.trackingCodeId = res.data.createTrackingCode.trackingCode.id
					if (!this.reservedaysData.population || this.reservedaysData.population === '설정 해제') {
						if (this.reservedaysData.accessPhones !== '' && this.reservedaysData.accessPhones !== null) {
							this.checkPhone()
						} else {
							this.reserveusers()
						}
					} else {
						this.checkPopulation()
					}
				})
				.catch(() => {})
		},
		async reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			await this.$store
				.dispatch('reservedays', data)
				.then(res => {
					this.reservedaysData = res.data.reservedays[0]
					if (res.data.reservedays[0].business) {
						if (res.data.reservedays[0].business.term) this.$store.state.termId = res.data.reservedays[0].business.term.id
						let li = []
						if (res.data.reservedays[0].business.useTerm) {
							li.push(res.data.reservedays[0].business.useTerm)
						} else li.push(null)

						if (res.data.reservedays[0].business.privacyTerm) {
							li.push(res.data.reservedays[0].business.privacyTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.uniqueTerm) {
							li.push(res.data.reservedays[0].business.uniqueTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.marketingTerm) {
							li.push(res.data.reservedays[0].business.marketingTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.adTerm) {
							li.push(res.data.reservedays[0].business.adTerm)
						} else li.push(null)

						this.$store.state.termIdList = li
					}
					// reservedays data 초기화
					this.$store.state.reservedayData = res.data.reservedays[0]
					if (res.data.reservedays[0].business.color) {
						this.$store.state.PointColor7 = res.data.reservedays[0].business.color
						this.nextbtn.color = res.data.reservedays[0].business.color

						this.startDialog.nametxtField.color = res.data.reservedays[0].business.color
						this.startDialog.numSel.color = res.data.reservedays[0].business.color
						this.startDialog.numtxtField.color = res.data.reservedays[0].business.color
					}
					if (res.data.reservedays[0].business.btnColor) {
						this.$store.state.PointColor8 = res.data.reservedays[0].business.btnColor
					}
					// this.campaignTitle = res.data.reservedays[0].title
					// tplCode 초기화
					this.$store.state.reservedayTplCode = this.reservedaysData.tplCode[1]
					// 설문 데이터 value 삽입
					if (res.data.reservedays[0].input_box !== null) {
						this.placeTitle = res.data.reservedays[0].title
						this.campaignTitle = res.data.reservedays[0].title
						res.data.reservedays[0].input_box.categories.forEach(element => {
							if (element.tag === 'location') {
								if (element.defalutLocation) {
									this.$store.state.searchsel_city1.value = element.defalutLocation.split('_')[0]
									this.loc_firstSelect(element.defalutLocation.split('_')[0])
									if (element.defalutLocation.split('_')[1]) {
										this.loc_twoSelect(element.defalutLocation.split('_')[1])
										this.$store.state.searchsel_city2.value = element.defalutLocation.split('_')[1]
									}
									if (element.defalutLocation.split('_')[2]) {
										this.$store.state.searchsel_city3.value = element.defalutLocation.split('_')[2]
									}
								} else {
									this.$store.state.searchsel_city2.items = location1['서울특별시'].sort()
									this.$store.state.searchsel_city3.items = location2['서울특별시']['강남구'].sort()
								}
							}
							if (element.type === 10) {
								element.value = ''
								element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
								element.nowRadioValue = ''
								element.etc = ''
							} else if (element.type === 11) {
								element.category_details.forEach(detail => {
									if (!element.items) {
										element.items = []
									}
									element.items.push({
										value: '',
										label: detail.detailname,
										color: '',
										class: '',
										errorMessage: '',
										hideDetail: true,
										detailcode: detail.detailcode,
									})
								})
							} else if (element.type === 12) {
								element.items = {
									label: '',
									value: '',
									errorMessage: '',
									hideDetail: true,
									outlined: true,
									color: this.$store.state.PointColor7,
								}
							} else if (element.type === 20) {
								element.items = {
									value: '',
									maxlength: '255',
									outlined: true,
									autofocus: false,
									hideDetail: false,
									errorMessage: '',
									color: this.$store.state.PointColor7,
								}
							}
						})
					} else {
						this.noInputBox = true
						this.placeTitle = res.data.reservedays[0].title
					}
					this.$store.commit('reservedayInputBox', res.data.reservedays[0].input_box)
					this.$store.commit('maxcount', res.data.reservedays[0].maxcount)
					this.$store.commit('nodaySetting', res.data.reservedays[0].nodaySetting)
					this.$store.commit('timeRange', res.data.reservedays[0].timeRange)
					this.$store.commit('startDate', res.data.reservedays[0].sdate)
					this.$store.commit('endDate', res.data.reservedays[0].edate)
					this.getLength()
					// 사업지명 찾기
					this.$store.state.groupname = this.$route.params.groupname
				})
				.catch(() => {})
		},

		reserveusers() {
			const data = {
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,

				code: this.$route.params.code,
			}
			this.$store
				.dispatch('simpleReserveusers', data)
				.then(res => {
					if (res.data.reserveusers.length === 0) {
						// reserveusers에 입력한 정보의 참가자가 없는 경우
						if (this.reservedaysData.input_box !== null) {
							this.reserveDialog.title = this.reservedaysData.input_box.name
						}
						if (this.reservedaysData.inputBoxType === '2') {
							this.reserveDialog1.dialog = true
							this.startDialog.dialog = false
						} else {
							if (this.reservedaysData.input_box) {
								this.startDialog.dialog = false
								this.reserveDialog.dialog = true
								this.reserveDialog.step1 = true
								this.reserveDialog.step2 = false
							} else {
								this.reserveDialog.step1 = false
								this.reserveDialog.step2 = true
								this.createReserveuser()
							}
						}
					} else {
						// reserveusers에 입력한 정보의 참가자가 있는 경우
						if (this.reservedaysData.duplicate) {
							// 캠페인 중복 참가 가능한 경우 -> duplicate 값이 true
							if (this.reservedaysData.input_box !== null) {
								this.reserveDialog.title = this.reservedaysData.input_box.name
							}
							if (this.reservedaysData.inputBoxType === '2') {
								this.reserveDialog1.dialog = true
								this.startDialog.dialog = false
							} else {
								if (this.reservedaysData.input_box) {
									this.startDialog.dialog = false
									this.reserveDialog.dialog = true
									this.reserveDialog.step1 = true
									this.reserveDialog.step2 = false
								} else {
									this.reserveDialog.step1 = false
									this.reserveDialog.step2 = true
									this.createReserveuser()
								}
							}
						} else {
							this.reservedaysData.duplicate = false
							// 캠페인 중복 참가 불가능한 경우 -> duplicate 값이 false
							this.alertModal2.text = '고객님은 해당 캠페인에 이미 참여하셨습니다. (중복참여 불가)'
							this.alertModal2.dialog = true
						}
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		startSurvey() {
			if (this.reservedaysData.noUserData) {
				this.reserveDialog.dialog = true
				this.reserveDialog.step1 = true
				this.reserveDialog.step2 = false
			} else {
				this.maxcountCheck()
			}
		},
		nextStep() {
			if (this.startDialog.nametxtField.value === '') {
				this.alertModal.text = '이름과 전화번호를 입력해 주세요.'
				return (this.alertModal.dialog = true)
			}
			if (this.startDialog.numtxtField.value === '') {
				this.alertModal.text = '이름과 전화번호를 입력해 주세요.'
				return (this.alertModal.dialog = true)
			}

			if (this.startDialog.numtxtField.value.length < 7) {
				this.alertModal.text = '휴대전화번호를 정확히 입력해주세요.'
				return (this.alertModal.dialog = true)
			}

			this.reserveDialog.inputUserData = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.reserveDialog1.inputUserData = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}

			if (!this.reservedaysData.population || this.reservedaysData.population === '설정 해제') {
				if (this.reservedaysData.accessPhones !== '' && this.reservedaysData.accessPhones !== null) {
					this.checkPhone()
				} else {
					this.reserveusers()
				}
			} else {
				this.checkPopulation()
			}
		},
		changeTypeText(data) {
			if (data === 11) {
				return 'checkbox'
			} else if (data === 10 || data === 12) {
				return 'checkone'
			} else if (data === 20) {
				return 'textfiled'
			}
		},
		change() {
			return {}
		},
		disableNext() {
			if (this.startDialog.numtxtField.value && this.startDialog.nametxtField.value) {
				this.nextbtn.disabled = false
			} else {
				this.nextbtn.disabled = true
			}
			this.reserveDialog.name = this.startDialog.nametxtField.value
		},
		clickdoneBtn() {
			this.reserveDialog.dialog = false
		},
		maxcountCheck() {
			this.$store.state.loading = true
			const data = {
				sdate:
					this.$moment(this.reservedaysData.sdate)
						.subtract(1, 'd')
						.format('YYYY-MM-DD') + ' 15:00:00',
				edate: this.$moment(this.reservedaysData.edate).format('YYYY-MM-DD') + ' 15:00:00',
				code: this.$route.params.code,
			}
			this.$store
				.dispatch('reserveusersConnection', data)
				.then(res => {
					let reserveAmount = res.data.reserveusersConnection.aggregate.count
					this.$store.state.loading = false

					if (
						this.$moment(this.$moment().format('YYYY-MM-DD HH:mm:ss')).isBetween(
							this.$moment(this.reservedaysData.sdate).format('YYYY-MM-DD HH:mm:ss'),
							this.$moment(this.reservedaysData.edate).format('YYYY-MM-DD HH:mm:ss'),
							undefined,
							'[]',
						)
					) {
						// 시작 이후 + 종료 이전
						if (reserveAmount >= this.reservedaysData.maxcount) {
							// 예약 인원 초과
							this.alertModal2.text = '해당 사업지의 상담 신청 예약인원이 초과되었습니다.'
							this.alertModal2.dialog = true
						} else {
							// 예약 가능
							this.startDialog.dialog = true
						}
					} else {
						if (this.$moment(this.$moment().format('YYYY-MM-DD')).isBefore(this.reservedaysData.edate.substring(0, 10))) {
							// 시작일 이전
							this.alertModal2.text = '본 캠페인(이벤트)은 시작 전입니다.'
							this.alertModal2.dialog = true
						} else {
							// 종료일 이후
							this.alertModal2.text = '본 캠페인(이벤트)은 종료되었습니다.'
							this.alertModal2.dialog = true
						}
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		checkPopulation() {
			const data = {
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
				inputBoxId: this.reservedaysData.population,
			}
			this.$store
				.dispatch('findReserveusers', data)
				.then(res => {
					if (res.data.reserveusers.length === 0) {
						this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
						return (this.alertModal.dialog = true)
					} else {
						this.reserveusers()
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		checkPhone() {
			let phone = this.startDialog.numSel.value + this.startDialog.numtxtField.value
			let realPhone = phone
				.replace(/[^0-9]/g, '')
				.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
				.replace('--', '-')
			let nameCheck = this.reservedaysData.accessPhones
				.filter(x => x.name === this.startDialog.nametxtField.value)
				.map(x => x.phone)
				.indexOf(realPhone)
			if (nameCheck !== -1) {
				this.reserveusers()
			} else {
				this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
				this.alertModal.dialog = true
				this.startDialog.dialog = false
			}
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		closePage() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
		createReserveuser() {
			let ismarketing
			// let date

			let serverDate = new Date()
			if (this.$store.state.check1.value) {
				ismarketing = 1
			} else if (this.$store.state.check4.value) {
				ismarketing = 2
			} else if (this.$store.state.check2.value && this.$store.state.check1.value === false && this.$store.state.check4.value === false) {
				ismarketing = 2
			} else if (this.$store.state.check3.value && this.$store.state.check1.value === false && this.$store.state.check4.value === false) {
				ismarketing = 1
			} else {
				ismarketing = 2
			}
			let area = ''
			if (this.reservedaysData.area) {
				area = this.reservedaysData.area
			}

			const data = {
				// inputBoxTitle: this.$store.state.reservedayInputBox.name,
				// inputBoxId: this.$store.state.reservedayInputBox.id,
				tracking_code: this.$store.state.trackingCodeId,
				name: this.reserveDialog.inputUserData.name,
				phone: this.reserveDialog.inputUserData.phone,

				code: this.$route.params.code,
				ismarketing: ismarketing,
				ispersonal: 1,
				rdate: serverDate,
				title: this.placeTitle,
				status: 1,
				type: this.reservedaysData.type,
				area: area,
				reserveType: this.$route.name === 'reserveday' ? 'day' : 'direct',
				marketing: this.$store.state.check5.value,
				receiveInformation: this.$store.state.check6.value,
				business: this.reservedaysData.business ? Number(this.reservedaysData.business.id) : null,
			}
			if (this.$route.params.subCode) {
				data.reserveGroupCode = this.$route.params.subCode
			}
			if (this.percent) {
				data.percent = this.percent
			}
			{
				this.$store
					.dispatch('createReserveuser', data)
					.then(() => {
						this.startDialog.dialog = false
						this.reserveDialog.dialog = true
						this.messages()
						// 예약 등록 시 메세지 발송
					})
					.catch(() => {
						this.$store.state.loading = false
					})
			}
		},
		// 생성 / 수정시 알림톡
		creaetSendMessage() {
			const now = new Date()
			const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			if (this.messageData1.message === undefined) {
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData1.message = this.messageData1.message.replace(/#{사업지명}/g, this.placeTitle)
				this.messageData1.message = this.messageData1.message.replace(/#{고객명}/g, this.reserveDialog.inputUserData.name)
				this.messageData1.message = this.messageData1.message.replace(/#{예약신청일시}/g, today)
				this.messageData1.message = this.messageData1.message.replace(/#{예약일시}/g, today)
				// this.messageData1.message = this.messageData1.message.replace(/#{고객정보}/g, url)
			}
			const data = {
				// 필수값

				code: this.$route.params.code,
				sender: this.messageData1.smssender,
				senderkey: this.messageData1.senderkey,
				tpl_code: this.messageData1.tplCode,
				receiver_1: this.reserveDialog.inputUserData.phone,
				subject_1: this.messageData1.tplCodeStr,
				message_1: this.messageData1.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.reserveDialog.inputUserData.name,
				failover: 'Y',
				fsubject_1: this.messageData1.tplCodeStr,
				fmessage_1: this.messageData1.message,
				button_1: this.messageData1.button ? this.messageData1.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {})
				.catch(() => {})
		},
		// 내가받을 알림톡 알림톡
		creaetSendMessage_My() {
			const now = new Date()
			const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			if (this.messageData4.message === undefined) {
				return
			} else {
				this.messageData4.message = this.messageData4.message.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
				this.messageData4.message = this.messageData4.message.replace(/#{고객명}/g, this.setdialog.inputUserData.name)
				this.messageData4.message = this.messageData4.message.replace(/#{예약신청일시}/g, today)
				this.messageData4.message = this.messageData4.message.replace(/#{예약일시}/g, today)
				this.messageData4.message = this.messageData4.message.replace(/#{고객번호}/g, this.setdialog.inputUserData.phone)
			}
			const data = {
				// 필수값

				code: this.$route.params.code,
				sender: this.messageData4.smssender,
				senderkey: this.messageData4.senderkey,
				tpl_code: this.messageData4.tplCode,
				receiver_1: this.reservedaysData.selfAlert.replace(/-/g, ''),
				subject_1: this.messageData4.tplCodeStr,
				message_1: this.messageData4.message,
				recvname_1: this.reserveDialog.inputUserData.name,
				failover: 'Y',
				fsubject_1: this.messageData4.tplCodeStr,
				fmessage_1: this.messageData4.message,
				button_1: this.messageData4.button ? this.messageData4.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {})
				.catch(() => {})
		},
		messages() {
			const data = {
				// tplCode: this.$store.state.reservedayTplCode,
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					// create / update 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 0
					let foundIndex1 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[0]
					})
					// delete 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 2
					let foundIndex4 = res.data.messages.findIndex(obj => {
						return obj.tplCode === this.$store.state.reservedayData.tplCode[12]
					})
					if (foundIndex1 !== -1) {
						this.messageData1 = res.data.messages[foundIndex1] // create / update 알림톡 데이터
					}
					if (foundIndex4 !== -1) {
						this.messageData4 = res.data.messages[foundIndex4] // 내가 받을 알림톡 알림톡 데이터
					}
					this.creaetSendMessage()
					if (this.reservedaysData.selfAlert !== '' && this.reservedaysData.selfAlert) {
						this.creaetSendMessage_My()
					}
				})
				.catch(() => {})
		},
	},
}
</script>

<style lang="scss">
.reserve-background-width {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}
.imageButton {
	text-align: end;
	padding: 20px;
}
.startVisit {
	background: white !important;
	padding: 20px 0px;
}
.cardTitle {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}
.guide {
	font-size: 13px;
	font-weight: bold;
	color: #606060;
}
.dialogBottom {
	.title {
		height: 50px;
		display: flex;
		align-items: center;
		text-align: center;
		background-color: #fdc85a;
		padding: 0 10px 0 30px;

		h2 {
			color: white;
			font-weight: bold;
			font-size: 18px;
		}

		.title-icon {
			color: white;
		}
	}
	.dialog-content {
		padding: 20px 20px 20px 20px;
	}
}
.hiddenTab {
	display: none;
}
</style>
<style lang="scss" scoped>
.reserveInfo {
	font-size: 14px;
	font-weight: bold;
	padding: 16px 16px 0px;
	color: #808080;
}
.duplicateInfo {
	font-size: 15px;
	margin-left: 16px;
	color: #808080;
}
</style>
